// removed by extract-text-webpack-plugin
module.exports = {"button":"PasswordReset__button___2uXHu"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/components/passwordReset/PasswordReset.css
// module id = 1213
// module chunks = 0